import { Card } from '@/components/ui/card';
import { Terminal as TerminalIcon } from 'lucide-react';

interface TerminalProps {
  deviceId: string;
}

const Terminal = ({ deviceId }: TerminalProps) => {
  return (
    <Card className="p-6">
      <div className="text-center py-12 text-muted-foreground">
        <TerminalIcon className="h-12 w-12 mx-auto mb-3 text-muted-foreground/50" />
        <p className="text-lg font-medium mb-2">Remote Terminal — Coming Soon</p>
        <p className="text-sm">Remote terminal requires backend Remote Terminal APIs.</p>
      </div>
    </Card>
  );
};

export default Terminal;
